var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column",staticStyle:{"min-width":"150px"}},[_c('div',{staticClass:"mx-auto",staticStyle:{"line-height":"14px"}},[_vm._v(" "+_vm._s(_vm.ticker)+" ")]),_c('div',{staticClass:"d-flex justify-center",class:{ 
    }},[_c('h1',{staticClass:"highlight-value"},[_vm._v(" "+_vm._s(_vm.changeValue)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }